//
import moment from 'moment'

/**
 * 
 * @param {*} val 
 */
export default function ( val ) {

    //
    const { payment_date, emission_date } = this.vmodels
        , hasDates = payment_date && emission_date
        , isBefore = hasDates && moment( emission_date ).isBefore( payment_date )

    //
    return hasDates ? isBefore || 'La fecha de pago debe ser posterior a la fecha de emisión' : 'Debe ingresar fecha de pago y fecha de emisión'
}